export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-at-sign-04f195aa3be37e0cf82b52e7446bc45e.svg";